import React, {useEffect} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useSelector, useDispatch} from 'react-redux';
import {
  userDataSelector,
  prevPageNameSelector,
  mpnfoSelector,
  tokenSelector,
  userCountrySelector,
} from '../../store/selectors';
import {updatePreviousPageName} from '../../store/actions';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import SetPassword from './containers/SetPassword';
import {updateUrlWithNewCrid} from '../../../../myaccount/src/utils/redirectWithCrId';

const CreatePassword = () => {
  const userInfo = useSelector(userDataSelector);
  const userCoutry = useSelector(userCountrySelector);
  const {email, mobile, requestIp, accountId} = userInfo;
  const data = useSelector(prevPageNameSelector);
  const mpnfoValue = useSelector(mpnfoSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  useEffect(() => {
    updateUrlWithNewCrid();
  }, []);

  useEffect(() => {
    const onPageLoad = () => {
      logPageLoadEvents('onboarding:setpasssword', {
        eVar15: 'onboarding:setpasssword|mypartner',
        eVar34: email,
        eVar35: mobile,
        eVar23: prevPageName,
        eVar28: requestIp,
        eVar67: accountId,
        eVar24: 'onboarding|mypartner',
        eVar37: userCoutry
          ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
          : 'domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng',
        eVar107: `mpnfo_${mpnfoValue}`,
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        prop27: '/agent/createpassword',
      });
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
    const events = {};

    dispatch(updatePreviousPageName('onboarding:setpasssword'));
  }, [dispatch]);

  return (
    <OnboardingNew step={3}>
      <SetPassword />
    </OnboardingNew>
  );
};

export default CreatePassword;
